import { ControllerBase } from "controllerBase";
import global from 'globalMU'

declare var window:any

const SimularFinanciamentoController = ControllerBase.extend({
    name: "SimularFinanciamentoController",
    framework: "knockout",
    ajax: function() {
        return {
            url: "/Orcamento/_SimularFinanciamento",
            type: "post"
        };
    },
    newModel: function() {
        return {
            CodigoPlanoPagamento: null,
            CodigoParcela: null,
            CodigoCarencia: null,
            ValorEntrada: 0,
            ValorFinanciado: 0,
            ValorParcela: 0,
            parcelas: [],
            carencias: [],
            tipoCalculo: "TipoCalculoValorDeParcelas"
        };

    },
    renderizado: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("#SimularFinanciamento_PlanoPagamento").focus();
    },
    antesBinding: function() {
        this.model.CodigoPlanoPagamento.subscribe($.proxy(this.codigoPlanoPagamentoAlterado, this));
        this.model.CodigoParcela.subscribe($.proxy(this.codigoParcelaAlterado, this));
        this.model.tipoCalculo.subscribe($.proxy(this.tipoCalculoAlterado, this));
    },
    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("#SimularFinanciamento_PlanoPagamento").focus();
    },
    codigoPlanoPagamentoAlterado: function() {
        var self = this;
        this.model.parcelas(undefined);
        this.model.carencias(undefined);
        if (!this.model.CodigoPlanoPagamento()) {
            return;
        }

        global.ajax({
            url: "/Orcamento/ListarParcelasPlanoPagamentoPorCodigo",
            type: "post",
            data: {
                codigoPlanoPagamento: this.model.CodigoPlanoPagamento()
            },
            success: function(data) {
                if (!data) {
                    return;
                }
                self.model.parcelas(data);
            }
        });
    },
    codigoParcelaAlterado: function() {
        var self = this;
        if (!this.model.CodigoParcela()) {
            return;
        }
        global.ajax({
            url: "/Orcamento/ListarCarenciasParcelaPlanoPagamentoPorCodigo",
            type: "post",
            data: {
                codigoParcela: this.model.CodigoParcela()
            },
            success: function(data) {
                if (!data) {
                    return;
                }
                self.model.carencias(data);
            }
        });
    },
    tipoCalculoAlterado: function() {
        this.model.ValorFinanciado(global.formatNumber(0));
        this.model.ValorParcela(global.formatNumber(0));
    },
    calcularFinanciamento: function() {
        if (!global.isFormValid("#form-simular-financiamento")) {
            return;
        }
        var self = this;

        if (this.model.tipoCalculo() == "TipoCalculoValorDeParcelas") {
            this.model.ValorParcela(global.formatNumber(0));
        } else {
            this.model.ValorFinanciado(global.formatNumber(0));
        }

        global.ajax({
            url: "/Orcamento/SimularFinanciamento",
            type: "post",
            data: {
                simularFinanciamento: this.toJS(this.model)
            },
            success: function(data) {
                if (!data) {
                    return;
                }
                self.model.ValorFinanciado(global.formatNumber(data.ValorFinanciado));
                self.model.ValorParcela(global.formatNumber(data.ValorParcela));
                if (!data.HasErrors) {
                    global.showSuccessMessage("Financiamento simulado com sucesso!");
                }
            }
        });
    }


});

window.SimularFinanciamentoController = SimularFinanciamentoController

export {
    SimularFinanciamentoController
}